import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Dialog from '../../../core/layout/Dialog';
import Separator from '../../../core/layout/Separator';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import FormButtons from '../../../core/form/FormButtons';
import TextInput from '../../../core/form/TextInput';
import Divider from '../../../core/layout/Divider';

const CreatePlacementItemDraftDialog = (props) => (
  <Dialog title="Create Draft" isOpen={props.isOpen} onCancel={props.onCancel} actions={null} width={1000}>
    <div>
      <b>Level</b>: <span>{get(props.grammarPlacementTestLevel, 'placementTestLevel.level', '')}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Grammar</b>: <span>{get(props.grammarPlacementTestLevel, 'grammar.name', '')}</span>
    </div>
    <Separator size="xxs" />
    <div>
      <b>Text</b>: <span>{get(props.item, 'text', '')}</span>
    </div>
    <Separator size="sm" />
    <Divider title="" />
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="What is the change reason?"
            fieldType="textarea"
            disabled={props.submitting || props.disabled}
            value={get(props.values, 'draftCreationReason', '')}
            onChange={(value) => props.onChange('draftCreationReason', value)}
            errorText={get(props.errors, 'draftCreationReason', '')}
            textAreaRows="4"
          />
        </Column>
      </Row>
      <Separator size="xs" />
      <FormButtons
        confirmLabel="Create"
        isDisabled={props.submitting || !props.isDirty()}
        isSubmitting={props.submitting}
        onReset={props.onCancel}
      />
    </form>
  </Dialog>
);

CreatePlacementItemDraftDialog.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  grammarPlacementTestLevel: PropTypes.shape({
    grammar: PropTypes.object,
    level: PropTypes.object,
  }),
  item: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  isDirty: PropTypes.func,
};

CreatePlacementItemDraftDialog.defaultProps = {
  isOpen: false,
  grammarPlacementTestLevel: null,
};

export default CreatePlacementItemDraftDialog;
